module.exports = __webpack_public_path__ + "img/color-vision.44dd122c.png";